export default __webpack_public_path__ + "static/media/logo_black.691d6bbb.png";